import { fetchJsonResponse } from '@/ai/api'
import { buildCommentReplyPrompt } from '@/ai/prompts'

export const generateCommentReply = async ({
  workflow,
  svgGraph,
  svgLanes,
  cardTypes,
  input,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }

  const messages = buildCommentReplyPrompt({
    workflow,
    svgGraph,
    svgLanes,
    cardTypes,
    input
  })

  try {
    const response = await fetchJsonResponse({
      messages,
      aiVersion: workflow.aiVersion,
      signal: abortController?.signal
    })

    return response || null
  } catch (error) {
    return null
  }
}
